import { Directive, HostListener } from '@angular/core';

@Directive({
	selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirectiveTsDirective {

	constructor() { }

	/**
	 * 限制input只能輸入0~9的數字
	 * @param event `KeyboardEvent`
	 */
	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		const allowedKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];
		if (allowedKeys.includes(event.key)) {
			return;
		}
	
		if (!event.key.match(/^[0-9]$/)) {
			event.preventDefault();
		}
	}
  
	/**
	 * 阻止複製貼上或輸入法
	 * @param event `Event`
	 */
	@HostListener('input', ['$event'])
	onInput(event: Event) {
		const input = event.target as HTMLInputElement;
		input.value = input.value.replace(/[^0-9]/g, '');
	}
}
